import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { cpf } from 'cpf-cnpj-validator';
import classNames from 'classnames';

import { AutoComplete } from 'primereact/autocomplete';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import { useListUnitysController } from 'src/controllers/Unitys/ListUnitysController';
import { useFormCreateUser } from 'src/controllers/User/CreateUserController';
import LoadingScreen from 'src/components/LoadingScreen';
import { InputMask } from 'primereact/inputmask';
import { useFormCreateUnityPeoples } from 'src/controllers/People/CreateUnityPeopleController';

interface filteredProps {
	label: string;
	value?: string;
}

const UserForm: React.FC = () => {
	const { getUserFormController, handleUserFormController } = useFormCreateUser();
	const { getUnityListController } = useListUnitysController();
	const { getUnityPeopleFormController } = useFormCreateUnityPeoples();

	const [valueUnity, setValueUnity] = useState('');
	const [filteredUnity, setFilteredUnity] = useState<filteredProps[]>([{ label: '', value: '' }]);
	const [valueRole, setValueRole] = useState('');
	const [filteredRole, setFilteredRole] = useState<filteredProps[]>([{ label: '', value: '' }]);

	const history = useHistory();
	const checkCpfCnpj = cpf.isValid(getUserFormController.formik.values.CPF || '');

	const accessLevel = [
		{ label: 'Secretário, prefeito e administradores', code: 0 },
		{ label: 'Motorista', code: 1 },
		{ label: 'Responsável por Oficina / Garagem', code: 2 },
	];

	useEffect(() => {
		if (getUserFormController.userResponse?.status === 200) {
			setValueUnity('');
			setValueRole('');
		}
	}, [getUserFormController.userResponse]);

	if (getUserFormController.loading) {
		return <LoadingScreen />;
	}

	const unitys = getUnityListController.AllUnitysData.map((unity) => {
		return { label: unity.NOME, value: unity.ID };
	});

	const roles = getUnityPeopleFormController.roles.map((role) => {
		return { label: role.DESCRICAO, value: role.ID };
	});

	const searchUnitys = (event: any) => {
		let filteredUnitys;
		if (!event.query.trim().length) {
			filteredUnitys = [...unitys];
		} else {
			filteredUnitys = unitys.filter((unity) => {
				return unity.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredUnity(filteredUnitys);
	};

	const searchRoles = (event: any) => {
		let filteredRoles;
		if (!event.query.trim().length) {
			filteredRoles = [...roles];
		} else {
			filteredRoles = roles.filter((role) => {
				return role.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredRole(filteredRoles);
	};

	return (
		<div style={{ height: '100%' }} className='card p-align-center p-justify-center'>
			<Toast ref={getUserFormController.toast} />
			<Toast ref={getUserFormController.toastUserCpf} />
			<h5>Cadastro de usuário</h5>
			{getUserFormController.loadingPersonCpf ? <LoadingScreen color='#0388e5' /> : <></>}
			<div className='p-grid p-fluid'>
				<div className='p-field p-col-12 p-md-2'>
					<label htmlFor='cpf'>CPF</label>
					<InputMask
						id='cpf'
						autoClear={false}
						mask='999.999.999-99'
						placeholder='___.___.___-__'
						{...getUserFormController.formik.getFieldProps('CPF')}
						onChange={(e) => getUserFormController.formik.setFieldValue('CPF', e.value)}
						onComplete={(e: any) => handleUserFormController.searchPersonCpf(e.value)}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getUserFormController.formik.touched.CPF &&
								(getUserFormController.formik.errors.CPF || !checkCpfCnpj),
							'popup-form-inactive': !(
								getUserFormController.formik.touched.CPF &&
								(getUserFormController.formik.errors.CPF || !checkCpfCnpj)
							),
						})}>
						{!checkCpfCnpj ? '* Informe CPF válido' : getUserFormController.formik.errors.CPF}
					</div>
				</div>
				<div className='p-field p-col-12 p-md-3'>
					<label htmlFor='email'>Email para usuário</label>
					<InputText
						id='email'
						maxLength={150}
						placeholder='exemplo@email.com.br'
						{...getUserFormController.formik.getFieldProps('LOGIN')}
						onChange={getUserFormController.formik.handleChange('LOGIN')}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getUserFormController.formik.touched.LOGIN && getUserFormController.formik.errors.LOGIN,
							'popup-form-inactive': !(
								getUserFormController.formik.touched.LOGIN && getUserFormController.formik.errors.LOGIN
							),
						})}>
						{getUserFormController.formik.errors.LOGIN}
					</div>
				</div>

				<div className='p-field p-col-12 p-md-3'>
					<label htmlFor='senha'>Senha para usuário</label>
					<InputText
						id='senha'
						maxLength={150}
						{...getUserFormController.formik.getFieldProps('SENHA')}
						onChange={getUserFormController.formik.handleChange('SENHA')}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getUserFormController.formik.touched.SENHA && getUserFormController.formik.errors.SENHA,
							'popup-form-inactive': !(
								getUserFormController.formik.touched.SENHA && getUserFormController.formik.errors.SENHA
							),
						})}>
						{getUserFormController.formik.errors.SENHA}
					</div>
				</div>

				<div className='p-field p-col-12 p-md-4'>
					<label htmlFor='nivel'>Nível de acesso</label>
					<Dropdown
						id='nivel'
						inputId='nivel'
						{...getUserFormController.formik.getFieldProps('NIVEL')}
						onChange={(e) => {
							getUserFormController.formik.setFieldValue('NIVEL', e.value);
						}}
						options={accessLevel}
						optionLabel='label'
						optionValue='code'
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getUserFormController.formik.touched.NIVEL && getUserFormController.formik.errors.NIVEL,
							'popup-form-inactive': !(
								getUserFormController.formik.touched.NIVEL && getUserFormController.formik.errors.NIVEL
							),
						})}>
						{getUserFormController.formik.errors.NIVEL}
					</div>
				</div>

				{getUserFormController.PersonCpf[0] && getUserFormController.PersonCpf[0].ORGAOUNIDADE === null ? (
					<>
						<div className='p-field p-col-12'>
							<label htmlFor='cargo'>Cargo</label>
							<AutoComplete
								id='cargo'
								value={valueRole}
								field='label'
								placeholder='Buscar...'
								onChange={(e) => {
									setValueRole(e.value);
									getUserFormController.formik.setFieldValue(
										'CARGO',
										filteredRole.find((role) => {
											return e.value === role.label;
										})?.value || ''
									);
								}}
								onSelect={(e) => {
									setValueRole(e.value.label);
									getUserFormController.formik.setFieldValue('CARGO', e.value.value);
								}}
								suggestions={filteredRole}
								completeMethod={searchRoles}
								dropdown
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getUserFormController.formik.touched.CARGO &&
										getUserFormController.formik.errors.CARGO,
									'popup-form-inactive': !(
										getUserFormController.formik.touched.CARGO &&
										getUserFormController.formik.errors.CARGO
									),
								})}>
								{getUserFormController.formik.errors.CARGO}
							</div>
						</div>

						<div className='p-field p-col-12'>
							<label htmlFor='unidade'>Unidade</label>
							<AutoComplete
								id='unidade'
								value={valueUnity}
								field='label'
								placeholder='Buscar...'
								onChange={(e) => {
									setValueUnity(e.value);
									getUserFormController.formik.setFieldValue(
										'ORGAOUNIDADE',
										filteredUnity.find((unity) => {
											return valueUnity.toLowerCase() === unity.label.toLowerCase();
										})?.value || ''
									);
								}}
								onSelect={(e) => {
									setValueUnity(e.value.label);
									getUserFormController.formik.setFieldValue('ORGAOUNIDADE', e.value.value);
								}}
								suggestions={filteredUnity}
								completeMethod={searchUnitys}
								dropdown
								dropdownMode='current'
								minLength={2}
								delay={0}
							/>
							<div
								className={classNames('p-invalid popup-fade', {
									'popup-form-active':
										getUserFormController.formik.touched.ORGAOUNIDADE &&
										getUserFormController.formik.errors.ORGAOUNIDADE,
									'popup-form-inactive': !(
										getUserFormController.formik.touched.ORGAOUNIDADE &&
										getUserFormController.formik.errors.ORGAOUNIDADE
									),
								})}>
								{getUserFormController.formik.errors.ORGAOUNIDADE}
							</div>
						</div>
					</>
				) : (
					<></>
				)}
			</div>

			<div className='p-fluid p-grid p-justify-between'>
				<div className='p-col-12 p-md-4'>
					<Button
						disabled={!getUserFormController.foundPersonCpf}
						type='button'
						label='Cadastrar'
						onClick={() =>
							checkCpfCnpj && getUserFormController.foundPersonCpf
								? getUserFormController.formik.handleSubmit()
								: {}
						}
					/>
				</div>

				<div className='p-col-12 p-md-4'>
					<Button
						type='button'
						className='p-button-secondary'
						label='Voltar para listagem'
						onClick={() => history.goBack()}
					/>
				</div>
			</div>
		</div>
	);
};

export default UserForm;
